import { useCallback, useEffect, useState } from 'react';
import axiosInstance from 'utils/axiosInterceptors';
import { TProcurementReturns } from 'utils/types';

type TCustomHookProps = {
  id: number | undefined;
  branchDomain: string | undefined;
};

const useFetchProcurementReturns = ({ id, branchDomain }: TCustomHookProps) => {
  const [procurementReturns, setProcurementReturns] = useState<
    TProcurementReturns[]
  >([]);

  const fetchProcurementReturns = useCallback(async () => {
    if (!id || !branchDomain) return;

    try {
      const res = await axiosInstance.get(
        `/api/v1/${branchDomain}/procurementReturns?page=1&pageSize=1000&orderBy=createdOn&orderByDesc=true&supplierId=${id}&isFloatingReturn=true&status=ReturnedToSupplier`
      );
      setProcurementReturns(res.data.data);
    } catch (error) {
      console.error(error);
    }
  }, [branchDomain, id]);

  useEffect(() => {
    fetchProcurementReturns();
  }, [fetchProcurementReturns]);

  return { procurementReturns };
};

export default useFetchProcurementReturns;
